module.exports = __webpack_public_path__ + "img/0-1.91d4c09d.png";